import { installSafeConsole } from "./safe-log";
installSafeConsole(console);
